import React from 'react';
import { Button } from '../../atoms/button';
import { ManagePayPalUpdateForm } from './ManagePayPalDialog';

interface SuspendFormDetails {
    description: React.ReactNode;
    buttonAppearance: 'new-primary' | 'new-warning';
    buttonText: string;
}

const getSuspendFormDetails = (isSuspended: boolean): SuspendFormDetails => {
    if (isSuspended) {
        return {
            description: (
                <p>Unsuspend charity&rsquo;s PayPal account and allow future PayPal givings</p>
            ),
            buttonAppearance: 'new-primary',
            buttonText: 'Unsuspend',
        };
    }

    return {
        description: (
            <p>Suspend charity&rsquo;s PayPal account and block future PayPal givings</p>
        ),
        buttonAppearance: 'new-warning',
        buttonText: 'Suspend',
    };
};

const SuspendPayPalForm = function SuspendPayPalForm({
    selectedCharity,
    onSubmit,
    isLoading,
}: ManagePayPalUpdateForm) {
    const { IsSuspended } = selectedCharity;
    const { description, buttonAppearance, buttonText } = getSuspendFormDetails(IsSuspended);

    return (
        <div className="layout-grouping-children">
            {description}
            <Button
                id="submit-paypal-details"
                appearance={buttonAppearance}
                onClick={() => onSubmit({
                    ...selectedCharity,
                    IsSuspended: !IsSuspended,
                })}
                isLoading={isLoading}
            >
                {buttonText}
            </Button>
        </div>
    );
};

export default SuspendPayPalForm;
